import {DocumentFormBuilderComponent} from "../document-form-builder.component";
import {OnInit} from "@angular/core";
import {Claim} from "../../../model/claim.model";
import {UtilitiesService} from "../../../utilities/utilities.service";
import {DocumentField} from "../../../model/document-field";
import {SmartqDocuments} from "../../../model/smartq-documents.model";
import {ClaimTypes} from "../../../model/claim-type.model";

export class DishonestyHelperFormBuilder extends DocumentFormBuilderComponent implements OnInit {

    constructor(claim: Claim){
        super(claim);
       this.documentFormClaimType = ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DISHONESTY];
    }

    setRequiredDocuments(){
        let requiredDocuments: DocumentField[] = [];
        requiredDocuments.push(new DocumentField('EVIDENCE', 'domesticHelperClaim.dmhClaimTypeDetails.lossDueToDishonesty.subSupportingDocs.evidence', SmartqDocuments.DMH_PROOFOFDAMAGE, true));
        requiredDocuments.push(new DocumentField('DOCOFVALUE', 'domesticHelperClaim.dmhClaimTypeDetails.lossDueToDishonesty.subSupportingDocs.docOfValue', SmartqDocuments.DMH_PURCHRTOFDMDLOSS, true));
        if(this.claim.getClaimDomesticHelper().getDishonestyHelper().getIsIncidentReport()){
            requiredDocuments.push(new DocumentField('POLICEREPORT', 'domesticHelperClaim.dmhClaimTypeDetails.lossDueToDishonesty.subSupportingDocs.policeReport', SmartqDocuments.DMH_POLICE, true));
        }
        this.requiredDocuments = requiredDocuments;
    }
}
